export abstract class MapAction {

  active: boolean;

}
